import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'vaping_duration'

const OPTIONS = [
  {
    value: 'less-than-3-months',
    translationKey:
      'pages.onboarding.vapingDuration.options.less-than-3-months',
  },
  {
    value: '3-12-months',
    translationKey: 'pages.onboarding.vapingDuration.options.3-12-months',
  },
  {
    value: '1-3-years',
    translationKey: 'pages.onboarding.vapingDuration.options.1-3-years',
  },
  {
    value: 'over-3-years',
    translationKey: 'pages.onboarding.vapingDuration.options.over-3-years',
  },
  {
    value: 'already-quit',
    translationKey: 'pages.onboarding.vapingDuration.options.already-quit',
  },
]

const ANSWER_TEXTS = {
  'less-than-3-months': 'Less than 3 months',
  '3-12-months': '3–12 months',
  '1-3-years': '1–3 years',
  'over-3-years': 'Over 3 years',
  'already-quit': "I've already quit",
}

export default function VapingDurationPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('answer') as string

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How long have you been vaping?',
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.vapingDuration.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
